import { emit, getSocket } from '../socket.config';
import { SOCKET_EVENTS } from '../socket.constants';
import { ISocketEvent } from '../socket.interface';

export const requestersSocket = {
    send: (key: string) => {
        emit(SOCKET_EVENTS.EVENT_JOIN_FLEETS, key);
    },
};

export const requestListeners = {
    onUpdate: (callback: (data: ISocketEvent) => void) => {
        const socket = getSocket();
        socket?.on(SOCKET_EVENTS.ORDER_UPDATES, callback);
        return () => {
            socket?.off(SOCKET_EVENTS.ORDER_UPDATES, callback);
        };
    },
};
